function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import KrpanoHotspotWrapper from './krpanoHotspotWrapper';
import KrpanoLayerWrapper from './krpanoLayerWrapper';
import requireKrpano from './requireKrpano';
/**
 * krpano 封装
 * @constructor
 * @param {string} id - 嵌入播放器的 div id
 * @param {Object} krpano - 原始 krpano 播放器对象
 */

var KrpanoWrapper = /*#__PURE__*/function () {
  function KrpanoWrapper(id, krpano) {
    _defineProperty(this, "gyroEnabled", false);

    _defineProperty(this, "autoRotateEnabled", false);

    _defineProperty(this, "autoRotateDuration", 0);

    _defineProperty(this, "hotspots", {});

    _defineProperty(this, "layers", {});

    this.id = id;
    this.krpano = krpano;
    this.init.bind(this).call();
    global.window.players[id] = this;
  }

  var _proto = KrpanoWrapper.prototype;

  _proto.init = function init() {
    var _this = this;

    var krpanoProperties = {
      base: ['idletime'],
      preview: ['type', 'url', 'striporder'],
      view: ['hlookat', 'vlookat', 'camroll', 'fovtype', 'fov', 'fovmin', 'fovmax', 'maxpixelzoom', 'mfovratio', 'distortion', 'distortionfovlink', 'stereographic', 'pannini', 'architectural', 'fisheye', 'architecturalonlymiddle', 'limitview', 'hlookatmin', 'hlookatmax', 'vlookatmin', 'vlookatmax', 'rx', 'ry', 'tx', 'ty', 'tz', 'ox', 'oy', 'oz'],
      display: ['autofullscreen', 'stereo', 'stereooverlap', 'stereoscale', 'monoside', 'anaglyph', 'safearea', 'mipmapping', 'loadwhilemoving', 'framebufferscale', 'hotspotvrrendering', 'hotspotworldscale', 'depthmaprendermode', 'depthbuffer', 'surfacesubdiv'],
      control: ['usercontrol', 'mouse', 'touch', 'dragrelative', 'draginertia', 'dragfriction', 'drag_oldmode', 'movetorelative', 'movetoaccelerate', 'movetospeed', 'movetofriction', 'movetoyfriction', 'frictionstop', 'invert', 'keybaccelerate', 'keybspeed', 'keybfriction', 'keybinvert', 'keybfovchange', 'mousefovchange', 'fovspeed', 'fovfriction', 'zoomtocursor', 'zoomoutcursor', 'disablewheel', 'touchzoom', 'keycodesleft', 'keycodesright', 'keycodesup', 'keycodesdown', 'keycodesin', 'keycodesout', 'keydownrepeat', 'bouncinglimits'],
      cursors: ['standard', 'dragging', 'moving', 'url', 'type', 'move', 'drag', 'arrow_l', 'arrow_r', 'arrow_u', 'arrow_d', 'arrow_lu', 'arrow_ru', 'arrow_ld', 'arrow_rd'],
      autorotate: ['enabled', 'waittime', 'accel', 'speed', 'horizon', 'tofov', 'oneroundrange', 'zoomslowdown', 'interruptionevents']
    };

    var _loop = function _loop(key) {
      if (krpanoProperties.hasOwnProperty(key)) {
        var properties = krpanoProperties[key];
        _this[key] = {};
        var _krpano = _this.krpano;
        properties.forEach(function (property) {
          if (key == 'base') {
            Object.defineProperty(_this, property, {
              get: function get() {
                return _krpano.get(property);
              },
              set: function set(value) {
                _krpano.set(property, value);
              }
            });
          } else {
            Object.defineProperty(_this[key], property, {
              get: function get() {
                return _krpano.get(key + '.' + property);
              },
              set: function set(value) {
                _krpano.set(key + '.' + property, value);
              }
            });
          }
        });
      }
    };

    for (var key in krpanoProperties) {
      _loop(key);
    }

    var eventsProperties = {
      'onEnterFullscreen': 'onenterfullscreen',
      'onExitFullscreen': 'onexitfullscreen',
      'onXmlComplete': 'onxmlcomplete',
      'onPreviewComplete': 'onpreviewcomplete',
      'onLoadComplete': 'onloadcomplete',
      'onBlendComplete': 'onblendcomplete',
      'onNewPano': 'onnewpano',
      'onRemovePano': 'onremovepano',
      'onNewScene': 'onnewscene',
      'onXmlError': 'onxmlerror',
      'onLoadError': 'onloaderror',
      'onKeyDown': 'onkeydown',
      'onKeyUp': 'onkeyup',
      'onClick': 'onclick',
      'onSingleClick': 'onsingleclick',
      'onDoubleClick': 'ondoubleclick',
      'onMouseDown': 'onmousedown',
      'onMouseUp': 'onmouseup',
      'onMouseWheel': 'onmousewheel',
      'onContextMenu': 'oncontextmenu',
      'onIdle': 'onidle',
      'onViewChange': 'onviewchange',
      'onViewChanged': 'onviewchanged',
      'onResize': 'onresize',
      'onFrameBufferreSize': 'onframebufferresize',
      'onAutoRotateStart': 'onautorotatestart',
      'onAutoRotateStop': 'onautorotatestop',
      'onAutoRotateOneRound': 'onautorotateoneround',
      'onAutoRotateChange': 'onautorotatechange',
      'onIphoneFullscreen': 'oniphonefullscreen',
      'gyroOnAvailable': 'gyro_onavailable',
      'gyroOnUnavailable': 'gyro_onunavailable',
      'gyroOnEnable': 'gyro_onenable',
      'gyroOnDisable': 'gyro_ondisable',
      'webvrOnAvailable': 'webvr_onavailable',
      'webvrOnUnavailable': 'webvr_onunavailable',
      'webvrOnUnknownDevice': 'webvr_onunknowndevice',
      'webvrOnEnterVr': 'webvr_onentervr',
      'webvrOnExitVr': 'webvr_onexitvr',
      'onLookToComplete': 'onLookToComplete'
    };
    var eventsKey = 'events';
    this[eventsKey] = {
      __playerId: this.id,
      __callbacks: {}
    };
    var krpano = this.krpano;

    var _loop2 = function _loop2(_key) {
      if (eventsProperties.hasOwnProperty(_key)) {
        var property = eventsProperties[_key];
        Object.defineProperty(_this[eventsKey], _key, {
          get: function get() {
            return this.__callbacks[_key];
          },
          set: function set(value) {
            if (value === undefined || value === null) {
              krpano.set(eventsKey + '.' + property, null);
              this.__callbacks[_key] = null;
              return;
            }

            if (_key == 'onClick' || _key == 'onSingleClick') {
              krpano.set(eventsKey + '.' + property, 'screentosphere(mouse.x, mouse.y, mouseH, mouseV); set(js_command, calc("if(window.patch_wait_hotspot_click != true){ window.players[\'' + this.__playerId + '\'].events.' + _key + '({id:\'' + this.__playerId + '\', ath:" + get(mouseH) + ",atv:" + get(mouseV) + "});};"));jscall(get(js_command));');
            } else if (_key == 'onDoubleClick' || _key == 'onMouseDown' || _key == 'onMouseUp') {
              krpano.set(eventsKey + '.' + property, 'screentosphere(mouse.x, mouse.y, mouseH, mouseV); set(js_command, calc("window.players[\'' + this.__playerId + '\'].events.' + _key + '({id:\'' + this.__playerId + '\', ath:" + get(mouseH) + ",atv:" + get(mouseV) + "});"));jscall(get(js_command));');
            } else if (_key == 'onViewChange' || _key == 'onViewChanged') {
              krpano.set(eventsKey + '.' + property, "if(view.hlookat != last_view_hlookat OR view.vlookat != last_view_vlookat OR view.fov != last_view_fov,\n                                copy(last_view_hlookat, view.hlookat);\n                                copy(last_view_vlookat, view.vlookat);\n                                copy(last_view_fov, view.fov);\n                                jscall(window.players['" + this.__playerId + "'].events." + _key + "(window.players['" + this.__playerId + "'].offsetedView()););\n                             );");
            } else {
              krpano.set(eventsKey + '.' + property, 'jscall(window.players[\'' + this.__playerId + '\'].events.' + _key + '(););');
            }

            this.__callbacks[_key] = value;
          }
        });
      }
    };

    for (var _key in eventsProperties) {
      _loop2(_key);
    }

    var actions = {
      // Animations / Animated value changing
      'tween': 'tween',
      'stopTween': 'stoptween',
      'tweenTypes': 'tweentypes',
      // Dynamic loading of other panos / tours
      'loadPano': 'loadpano',
      'loadScene': 'loadscene',
      'loadPanoScene': 'loadpanoscene',
      'loadXml': 'loadxml',
      'includeXml': 'includexml',
      'openurl': 'openurl',
      // Viewing animations / Camera control
      'lookAt': 'lookat',
      'lookTo': 'lookto',
      'lookToHotspot': 'looktohotspot',
      'moveTo': 'moveto',
      'zoomTo': 'zoomto',
      'adjustHLookAt': 'adjusthlookat',
      'adjust360': 'adjust360',
      'getLookToDistance': 'getlooktodistance',
      'stopLookTo': 'stoplookto',
      'stopMovements': 'stopmovements',
      'wait': 'wait',
      'onInterrupt': 'oninterrupt',
      // Automatic rotation
      'autoRotateStart': 'autorotate.start',
      'autoRotateStop': 'autorotate.stop',
      'autoRotateInterrupt': 'autorotate.interrupt',
      'autoRotatePause': 'autorotate.pause',
      'autoRotateResume': 'autorotate.resume',
      // Coordinate transformation
      'screenToSphere': 'screentosphere',
      'sphereToScreen': 'spheretoscreen',
      'screenToLayer': 'screentolayer',
      'layerToScreen': 'layertoscreen',
      'sphereToSpace': 'spheretospace',
      'spaceToSphere': 'spacetosphere',
      'remapFovType': 'remapfovtype',
      // Text visualization
      'showText': 'showtext',
      // View / Pano updates
      'updateObject': 'updateobject',
      'updateScreen': 'updatescreen',
      'invalidateScreen': 'invalidatescreen',
      // Dynamic adding or removing of screen elements
      'addLayer': 'addlayer',
      'addPlugin': 'addplugin',
      'removeLayer': 'removelayer',
      'removePlugin': 'removeplugin',
      'addHotspot': 'addhotspot',
      'removeHotspot': 'removehotspot',
      'showLog': 'showLog'
    };

    for (var _key2 in actions) {
      if (actions.hasOwnProperty(_key2)) {
        (function () {
          var element = actions[_key2];

          _this[_key2] = function () {
            for (var _len = arguments.length, arg = new Array(_len), _key3 = 0; _key3 < _len; _key3++) {
              arg[_key3] = arguments[_key3];
            }

            var command = element + '(' + arg.join(',') + ');';
            this.krpano.call(command);

            if (this.debug) {
              console.log('call krpano action: ' + command);
            }

            ;
          };
        })();
      }
    }

    Object.defineProperty(this, 'hotspotCount', {
      get: function get() {
        return krpano.get('hotspot.count');
      }
    });
  };

  _proto.call = function call(action) {
    this.krpano.call(action);
  };

  _proto.get = function get(property) {
    return this.krpano.get(property);
  };

  _proto.set = function set(property, value) {
    return this.krpano.set(property, value);
  };

  _proto.offsetedView = function offsetedView() {
    if (this.viewOffset) {
      return _extends({}, this.view, {
        hlookat: this.view.hlookat - this.viewOffset.hLookAt,
        vlookat: this.view.vlookat - this.viewOffset.vLookAt,
        fov: this.view.fov - this.viewOffset.fov
      });
    } else {
      return this.view;
    }
  };

  _proto.addHotspotById = function addHotspotById(id) {
    var hotspot = new KrpanoHotspotWrapper(id, this.krpano);
    this.addHotspot(id);
    hotspot.originId = id;
    this.hotspots[id] = hotspot;
    return hotspot;
  };

  _proto.getHotspotById = function getHotspotById(id) {
    return this.hotspots[id];
  };

  _proto.removeHotspotById = function removeHotspotById(id) {
    this.removeHotspot(id);
    this.hotspots[id] = undefined;
  };

  _proto.removeAllHotspots = function removeAllHotspots() {
    for (var id in this.hotspots) {
      this.removeHotspotById(id);
    }
  };

  _proto.addLayerById = function addLayerById(id) {
    var layer = new KrpanoLayerWrapper(id, this.krpano);
    this.addLayer(id);
    this.layers[id] = layer;
    return layer;
  };

  _proto.getLayerById = function getLayerById(id) {
    return this.layers[id];
  };

  _proto.removeLayerById = function removeLayerById(id) {
    this.removeLayer(id);
    this.layers[id] = undefined;
  };

  return KrpanoWrapper;
}();

export { KrpanoWrapper as default };
KrpanoWrapper.prototype.idPrefix = 'player_';

KrpanoWrapper.prototype.generateId = function (target) {
  return this.idPrefix + target;
};

global.window.players = {};
KrpanoWrapper.prototype.customKrpanoJS = undefined; // KrpanoWrapper.prototype.players = {};

KrpanoWrapper.prototype.krpanos = {};
KrpanoWrapper.prototype.krpanosCallback = {};

KrpanoWrapper.prototype.embedKrp = function (target, enableSnapshoot, backgroundColor, wmode, onready, lensFlarePlugin) {
  var id = this.generateId(target);

  if (this.krpanos[id] !== undefined) {
    this.removePlayer(target);
  }

  KrpanoWrapper.prototype.embedKrpRetry = 0;
  this.krpanosCallback[id] = onready;
  this.__lensFlarePlugin = lensFlarePlugin;
  var obj = {
    swf: 'krpano.swf',
    xml: null,
    target: target,
    id: id,
    html5: 'auto',
    mobilescale: 1.0,
    onready: this.krpanoOnReadyCallback.bind(this)
  };

  if (enableSnapshoot) {
    obj.webglsettings = {
      preserveDrawingBuffer: true
    };
  }

  if (backgroundColor) {
    obj.bgcolor = backgroundColor;
  }

  if (wmode) {
    obj.wmode = wmode;
  }

  if (window.embedpano) {
    setTimeout(function () {
      window.embedpano(obj);
    }, 120);
  } else {
    requireKrpano(KrpanoWrapper.prototype.customKrpanoJS).then(function () {
      window.embedpano(obj);
    });
  }
};

KrpanoWrapper.prototype.removePlayer = function (target) {
  var id = this.generateId(target);
  this.krpanos[id] = undefined;
  this.krpanosCallback[id] = undefined;
  this.__lensFlarePlugin = undefined;
  this.events = undefined;

  if (global.window.players[id].krpanoObj) {
    global.window.players[id].krpanoObj = undefined;
  }

  if (global.window.players[id].krpanoWebGL) {
    global.window.players[id].krpanoWebGL.context.getExtension('WEBGL_lose_context').loseContext();
    global.window.players[id].krpanoWebGL = undefined;
  }

  removepano(id);
  global.window.players[id] = undefined;
};

KrpanoWrapper.prototype.krpanoOnReadyCallback = function (krpano_interface) {
  this.krpanos[krpano_interface.id] = krpano_interface;
  this.__lensFlarePlugin && krpano_interface.set('flare_dir', this.__lensFlarePlugin);
  this.getPlayer(krpano_interface.id.replace(this.idPrefix, ''));
  this.__lensFlarePlugin && krpano_interface.call("includexml(" + this.__lensFlarePlugin + "/lensflare.xml, jscall(window.players['" + krpano_interface.id + "'].krpanosCallback['" + krpano_interface.id + "'](window.players['" + krpano_interface.id + "'].getPlayer('" + krpano_interface.id.replace(this.idPrefix, '') + "'));););");
  !this.__lensFlarePlugin && krpano_interface.call("jscall(window.players['" + krpano_interface.id + "'].krpanosCallback['" + krpano_interface.id + "'](window.players['" + krpano_interface.id + "'].getPlayer('" + krpano_interface.id.replace(this.idPrefix, '') + "')););");
};

KrpanoWrapper.prototype.getPlayer = function (target) {
  var id = this.generateId(target);
  var player = global.window.players[id];

  if (player !== undefined) {
    return player;
  }

  player = this.krpanos[id];

  if (player === undefined) {
    return undefined;
  }

  global.window.players[id] = new KrpanoWrapper(id, player);
  return global.window.players[id];
};